<template>
  <div>
    <div id="body">
      <div class="banner">
        <div class="wrapper">
          <div class="title">
            <h1>全国宏观月度库<sub>National Macro Monthly Library</sub></h1>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <el-row :gutter="20">
          <el-col :span="6"
                  style="height: 750px">
            <div class="left-filter">
              <div class="title"
                   @click="leftFilterShow = !leftFilterShow">
                <h4>
                  <img src="~@/assets/images/icon-f-class.png"
                       alt="" />选择指标
                </h4>
                <i v-if="leftFilterShow"
                   class="el-icon-arrow-up"></i><i v-else
                   class="el-icon-arrow-down"></i>
              </div>
              <div class="search">
                <el-input size="mini"
                          placeholder="输入关键字进行过滤"
                          v-model="filterText">
                </el-input>
              </div>
              <div :class="leftFilterShow ? 'content  show-this' : 'content'"
                   v-loading="treeLoading">
                <!-- <el-tree
                  :props="treeProps"
                  :load="loadNode"
                  node-key="code"
                  lazy
                  show-checkbox
                  @check-change="handleCheckChange"
                  ref="tree"
                  :indent="0"
                >
                </el-tree> -->

                <el-tree :props="treeProps"
                         node-key="code"
                         show-checkbox
                         @check-change="handleCheckChange"
                         ref="tree"
                         :indent="0"
                         :data="treeData"
                         :filter-node-method="filterNode">
                </el-tree>
              </div>
            </div>
          </el-col>
          <el-col :span="18"
                  style="height: 750px">
            <div class="search-filter">
              <el-form>
                <el-form-item>
                  <div class="item-block">
                    <span class="inner-label">时间范围：</span>
                    <el-date-picker v-model="selectDate"
                                    size="small"
                                    type="monthrange"
                                    range-separator="至"
                                    start-placeholder="开始月份"
                                    end-placeholder="结束月份"
                                    format="yyyy年MM月">
                    </el-date-picker>
                  </div>
                  <div class="item-block">
                    <el-button size="small"
                               @click="handleSearch">
                      查询
                    </el-button>
                    <el-button size="small"
                               @click="handleReset">重置</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="graph-box">
              <div class="type-filter">
                <el-radio-group v-model="graphType"
                                @change="handleGraphTypeChange">
                  <el-radio-button label="1">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type1.png" />
                    <span class="text">原始表格</span>
                  </el-radio-button>
                  <el-radio-button label="2"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type2.png" />
                    <span class="text">地图</span>
                  </el-radio-button>
                  <el-radio-button label="3">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type3.png" />
                    <span class="text">折线图</span>
                  </el-radio-button>
                  <el-radio-button label="4">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type4.png" />
                    <span class="text">柱状图</span>
                  </el-radio-button>
                  <el-radio-button label="5">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type5.png" />
                    <span class="text">条形图</span>
                  </el-radio-button>
                  <el-radio-button label="6">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type6.png" /><span class="text">堆积柱状图</span>
                  </el-radio-button>
                  <el-radio-button label="7">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type7.png" /><span class="text">堆积条形图</span>
                  </el-radio-button>
                  <el-radio-button label="8"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type8.png" /><span class="text">面积图</span>
                  </el-radio-button>
                  <el-radio-button label="9"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type9.png" /><span class="text">环形图</span>
                  </el-radio-button>
                  <el-radio-button label="10"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type10.png" /><span class="text">雷达图</span>
                  </el-radio-button>
                  <el-radio-button label="11"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type11.png" /><span class="text">填充雷达图</span>
                  </el-radio-button>
                  <el-radio-button label="12"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type12.png" /><span class="text">散点图</span>
                  </el-radio-button>
                </el-radio-group>
                <el-button-group>
                  <el-button :class="seriesLableShow ? 'is-active' : ''"
                             @click="
                      () => {
                        this.seriesLableShow = !this.seriesLableShow;
                        this.handleGraphTypeChange();
                      }
                    ">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type13.png" />
                    <span class="text">数值标签</span>
                  </el-button>
                  <el-button :class="legendShow ? 'is-active' : ''"
                             @click="
                      () => {
                        this.legendShow = !this.legendShow;
                        this.handleGraphTypeChange();
                      }
                    ">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type14.png" />
                    <span class="text">图例</span>
                  </el-button>
                </el-button-group>
                <el-button-group>
                  <el-button disabled
                             type="">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type15.png" />
                    <span class="text">收藏</span>
                  </el-button>
                  <el-button @click="handleExport">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type16.png" />
                    <span class="text">下载</span>
                  </el-button>
                </el-button-group>
              </div>
              <div class="chat-usage"
                   v-if="!showTable">
                <div class="tip">
                  <p>1、在左侧“选择指标”中勾选数据维度；</p>
                  <p>2、在上方选择“时间范围”，点击查询即可；</p>
                  <p>3、通过点击图表类型，切换数据显示方式，并下载原始数据；</p>
                  <p>4、单次查询最多可以展示数据10000条。</p>
                </div>

                <div class="intro">
                  <div class="intro-title">全国宏观月度库</div>
                  <div class="intro-row intro-row-bg">
                    <div class="intro-row-left">数据来源：</div>
                    <div class="intro-row-right">国家统计局公开数据</div>
                  </div>
                  <div class="intro-row">
                    <div class="intro-row-left">数据总量：</div>
                    <div class="intro-row-right">15万+</div>
                  </div>
                  <div class="intro-row intro-row-bg">
                    <div class="intro-row-left">数据起止时间：</div>
                    <div class="intro-row-right">
                      1989年1月-{{ new Date().getFullYear() - 1 }}年{{
                        new Date().getMonth()
                      }}月
                    </div>
                  </div>
                  <div class="intro-row">
                    <div class="intro-row-left">更新频率：</div>
                    <div class="intro-row-right">每月更新</div>
                  </div>
                  <div class="intro-row intro-row-bg">
                    <div class="intro-row-left">最近更新时间：</div>
                    <div class="intro-row-right">
                      {{ dateFormat(new Date(), "yyyy年MM月") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="graph"
                   v-show="showTable && graphType == '1'"
                   v-loading="tableLoading">
                <el-table :data="tableData"
                          style="width: 100%"
                          v-if="showTable && tableData && tableData.length > 0">
                  <el-table-column prop="date"
                                   label="日期"></el-table-column>
                  <el-table-column prop="dyzStrdata"
                                   :label="'当期值' + (dyzUnit ? '（' + dyzUnit + '）' : '')">
                  </el-table-column>
                  <el-table-column prop="ljzStrdata"
                                   :label="'累计值' + (ljzUnit ? '（' + ljzUnit + '）' : '')">
                  </el-table-column>
                  <el-table-column prop="tbzzStrdata"
                                   :label="
                      '同比增长' + (tbzzUnit ? '（' + tbzzUnit + '）' : '')
                    ">
                  </el-table-column>
                  <el-table-column prop="ljzzStrdata"
                                   :label="
                      '累计增长' + (ljzzUnit ? '（' + ljzzUnit + '）' : '')
                    ">
                  </el-table-column>
                </el-table>
                <div class="no-data"
                     v-if="showTable && (!tableData || tableData.length === 0)">
                  <div class="tip">
                    <svg t="1626241932884"
                         class="icon"
                         viewBox="0 0 1428 1024"
                         version="1.1"
                         xmlns="http://www.w3.org/2000/svg"
                         p-id="2321"
                         width="60"
                         height="60">
                      <path d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                            p-id="2322"></path>
                      <path d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                            p-id="2323"></path>
                      <path d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                            p-id="2324"></path>
                      <path d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                            p-id="2325"></path>
                      <path d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                            p-id="2326"></path>
                      <path d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                            p-id="2327"></path>
                    </svg>
                    <div class="text">暂无数据</div>
                  </div>
                </div>
              </div>

              <div class="graph"
                   v-show="showTable && graphType != '1'"
                   v-loading="tableLoading">
                <div id="graphTypeCharts"
                     style="width: 100%; height: 100%"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import * as echarts from "echarts";
import { exportTongjiDownload } from "../../util/utils";

export default {
  data () {
    return {
      leftFilterShow: false,
      graphShow: ["", ""],
      graphType: "1",

      showTooltip: "",
      topTabs: "t1",
      guidTabs: "t1-g1",
      guidTabsMore: false,

      treeLoading: false,
      treeData: [],
      treeProps: {
        label: "name",
        disabled: (data, node) => {
          return !node.isLeaf;
        },
        isLeaf: "isLeaf",
      },
      valueCodes: [],

      selectDate: [],

      dyzUnit: "",
      ljzUnit: "",
      tbzzUnit: "",
      ljzzUnit: "",

      records: [],
      yearCodeArray: [],
      dateCategoryData: [],
      tableLoading: false,
      tableData: [],
      cnameTableHead: [],
      cnameTableHeadUnit: [],
      showTable: false,
      seriesLableShow: false,
      legendShow: true,

      filterText: "",
    };
  },
  created () {
    this.getTreeList();
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1 && data.isLeaf;
    },
    getTreeList () {
      this.treeLoading = true;
      axiosRequest(
        "/region-data-index/all-tree-list",
        { type: "hgyd" },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.treeData = res.data.data;
          }
          this.treeLoading = false;
        })
        .catch(() => {
          this.treeLoading = false;
        });
    },
    handleExport () {
      if (!this.valueCodes || this.valueCodes.length === 0) {
        this.$message({ message: "请选择指标！", type: "warning" });
        return;
      }

      if (!this.selectDate || this.selectDate.length === 0) {
        this.$message({ message: "请选择时间范围！", type: "warning" });
        return;
      }

      let startYearCode = "",
        endYearCode = "",
        text = "";
      this.valueCodes.forEach((valueCode) => {
        if (text) {
          text += ";";
        }
        text += valueCode;
      });
      if (this.selectDate && this.selectDate.length > 0) {
        startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
      }
      if (this.selectDate && this.selectDate.length > 1) {
        endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
      }

      let url = `${process.env.VUE_APP_BASE_API}/search/export-region-data-table-zb`;
      let data = `valueCode=${text}&region=全国&tag=hgyd&startYearCode=${startYearCode}&endYearCode=${endYearCode}`;
      // let data = `valueCode=A020919&region=全国&tag=hgyd&startYearCode=${startYearCode}&endYearCode=${endYearCode}`;

      exportTongjiDownload(url, "全国宏观月度库", data);
    },
    handleGraphTypeChange (val) {
      if (this.graphType === "1" || !this.showTable) {
        return;
      }

      this.tableLoading = true;

      let type = "",
        stack = "";
      switch (this.graphType) {
        case "3":
          type = "line";
          break;
        case "4":
        case "5":
          type = "bar";
          break;
        case "6":
        case "7":
          type = "bar";
          stack = "total";
          break;
      }

      let series = [];
      let legendData = [
        "当期值" + (this.dyzUnit ? "（" + this.dyzUnit + "）" : ""),
        "累计值" + (this.ljzUnit ? "（" + this.ljzUnit + "）" : ""),
        // "同比增长" + (this.tbzzUnit ? "（" + this.tbzzUnit + "）" : ""),
        // "累计增长" + (this.ljzzUnit ? "（" + this.ljzzUnit + "）" : ""),
      ];

      let dyzData = this.records["当期值"];
      let ljzData = this.records["累计值"];
      // let tbzzData = this.records["同比增长"];
      // let ljzzData = this.records["累计增长"];

      let dyzValueData = [];
      let ljzValueData = [];
      // let tbzzValueData = [];
      // let ljzzValueData = [];
      this.yearCodeArray.forEach((yearCode) => {
        let dyzItem = dyzData.find((item) => item.yearCode === yearCode);
        let ljzItem = ljzData.find((item) => item.yearCode === yearCode);
        // let tbzzItem = tbzzData.find((item) => item.yearCode === yearCode);
        // let ljzzItem = ljzzData.find((item) => item.yearCode === yearCode);

        dyzValueData.push(dyzItem ? dyzItem.strdata : "0");
        ljzValueData.push(ljzItem ? ljzItem.strdata : "0");
        // tbzzValueData.push(tbzzItem ? tbzzItem.strdata : "0");
        // ljzzValueData.push(ljzzItem ? ljzzItem.strdata : "0");
      });

      series.push({
        name: legendData[0],
        type: type,
        stack: stack,
        label: { show: this.seriesLableShow },
        emphasis: {
          focus: "series",
        },
        data: dyzValueData,
      });
      series.push({
        name: legendData[1],
        type: type,
        stack: stack,
        label: { show: this.seriesLableShow },
        emphasis: {
          focus: "series",
        },
        data: ljzValueData,
      });
      // series.push({
      //   name: legendData[2],
      //   type: type,
      //   yAxisIndex: this.graphType == 5 ? 0 : 1,
      //   xAxisIndex: this.graphType == 5 ? 1 : 0,
      //   label: { show: this.seriesLableShow },
      //   emphasis: {
      //     focus: "series",
      //   },
      //   data: tbzzValueData,
      // });
      // series.push({
      //   name: legendData[3],
      //   type: type,
      //   yAxisIndex: this.graphType == 5 ? 0 : 1,
      //   xAxisIndex: this.graphType == 5 ? 1 : 0,
      //   label: { show: this.seriesLableShow },
      //   emphasis: {
      //     focus: "series",
      //   },
      //   data: ljzzValueData,
      // });

      const myChart = echarts.init(document.getElementById("graphTypeCharts"));
      switch (this.graphType) {
        case "3":
          myChart.setOption(
            {
              tooltip: {
                trigger: "axis",
              },
              legend: {
                show: this.legendShow,
                data: legendData,
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              // toolbox: {
              //   feature: {
              //     saveAsImage: {},
              //   },
              // },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: this.dateCategoryData,
              },
              // yAxis: {
              //   type: "value",
              // },
              yAxis: [
                {
                  type: "value",
                  name: "",
                  // min: 0,
                  // max: 11000,
                  position: "left",
                  axisLine: {
                    lineStyle: {},
                  },
                  axisLabel: {
                    formatter: "{value}",
                  },
                },
                // {
                //   type: "value",
                //   name: "增长",
                //   // min: 0,
                //   // max: 200,
                //   position: "right",
                //   axisLine: {
                //     lineStyle: {},
                //   },
                //   axisLabel: {
                //     formatter: "{value}",
                //   },
                // },
              ],
              series: series,
            },
            true
          );
          break;
        case "4":
        case "6":
          myChart.setOption(
            {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {
                show: this.legendShow,
                data: legendData,
              },
              xAxis: {
                type: "category",
                data: this.dateCategoryData,
              },
              yAxis: [
                {
                  type: "value",
                  name: "",
                  // min: 0,
                  // max: 11000,
                  position: "left",
                  axisLine: {
                    lineStyle: {},
                  },
                  axisLabel: {
                    formatter: "{value}",
                  },
                },
                // {
                //   type: "value",
                //   name: "增长",
                //   // min: 0,
                //   // max: 200,
                //   position: "right",
                //   axisLine: {
                //     lineStyle: {},
                //   },
                //   axisLabel: {
                //     formatter: "{value}",
                //   },
                // },
              ],
              series: series,
            },
            true
          );
          break;
        case "5":
        case "7":
          myChart.setOption(
            {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {
                show: this.legendShow,
                data: legendData,
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              xAxis: [
                {
                  type: "value",
                  name: "",
                  // min: 0,
                  // max: 11000,
                  position: "left",
                  axisLine: {
                    lineStyle: {},
                  },
                  axisLabel: {
                    formatter: "{value}",
                  },
                },
                // {
                //   type: "value",
                //   name: "增长",
                //   // min: 0,
                //   // max: 200,
                //   position: "right",
                //   axisLine: {
                //     lineStyle: {},
                //   },
                //   axisLabel: {
                //     formatter: "{value}",
                //   },
                // },
              ],
              yAxis: [
                {
                  type: "category",
                  axisTick: {
                    show: false,
                  },
                  data: this.dateCategoryData,
                },
              ],
              series: series,
            },
            true
          );
          break;
      }

      this.tableLoading = false;
    },
    async loadNode (node, resolve) {
      let parentId = -1;
      if (node.level === 0) {
        parentId = 0;
      } else if (node.data && node.data.id) {
        parentId = node.data.id;
      }

      let data = [];

      if (parentId > -1) {
        data = await this.getTreeList(parentId, "hgyd");
      }

      return resolve(data);
    },
    // async getTreeList(parentId, type) {
    //   let result = [];

    //   await axiosRequest(
    //     "/region-data-index/tree-list",
    //     { parentId: parentId, type: type },
    //     axiosOptions("post", "", "json")
    //   )
    //     .then((res) => {
    //       if (res.data && res.data.code === 200) {
    //         result = res.data.data;
    //       }
    //     })
    //     .catch(() => {});

    //   return result;
    // },
    handleCheckChange (data, checked) {
      if (checked) {
        this.valueCodes = [data.code];
        this.$refs.tree.setCheckedKeys(this.valueCodes, false);
      }

      // this.valueCodes.push(data.code);
      // this.checked = checked;
      // // 该节点未选中的时候
      // for (var i = 0; i <= this.valueCodes.length; i++) {
      //   if (this.checked == false) {
      //     this.valueCodes.splice(this.valueCodes.indexOf(this.i), 1);
      //   }
      // }
    },
    handleSearch () {
      if (!this.valueCodes || this.valueCodes.length === 0) {
        this.$message({ message: "请选择指标！", type: "warning" });
        return;
      }

      if (!this.selectDate || this.selectDate.length === 0) {
        this.$message({ message: "请选择时间范围！", type: "warning" });
        return;
      }

      this.pageIndex = 1;
      this.tableData = [];
      this.records = [];
      this.yearCodeArray = [];
      this.dateCategoryData = [];
      this.cnameTableHead = [];
      this.cnameTableHeadUnit = [];
      this.graphType = "1";
      this.regionDataTableMatch();
    },
    handleReset () {
      this.valueCodes = [];
      this.$refs.tree.setCheckedKeys(this.valueCodes, false);
      this.selectDate = [];
    },
    regionDataTableMatch () {
      this.tableLoading = true;
      let startYearCode = "",
        endYearCode = "",
        text = "";
      this.valueCodes.forEach((valueCode) => {
        if (text) {
          text += ";";
        }
        text += valueCode;
      });
      if (this.selectDate && this.selectDate.length > 0) {
        startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
      }
      if (this.selectDate && this.selectDate.length > 1) {
        endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
      }

      this.showTable = true;

      axiosRequest(
        "/search/region-data-table-zb",
        {
          valueCode: text, //"A020919",
          region: "全国",
          tag: "hgyd",
          startYearCode: startYearCode,
          endYearCode: endYearCode,
          pageIndex: this.pageIndex,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data.code === 200) {
            this.records = res.data.data;
            let dyzData = this.records["当期值"];
            let ljzData = this.records["累计值"];
            let tbzzData = this.records["同比增长"];
            let ljzzData = this.records["累计增长"];

            this.yearCodeArray = [];
            if (dyzData && dyzData.length > 0) {
              this.yearCodeArray = dyzData.map((item) => {
                if (item.yearCode && item.yearCode.length === 4) {
                  return item.yearCode + "00";
                }
                return item.yearCode;
              });
            } else if (ljzData && ljzData.length > 0) {
              this.yearCodeArray = ljzData.map((item) => {
                if (item.yearCode && item.yearCode.length === 4) {
                  return item.yearCode + "00";
                }
                return item.yearCode;
              });
            } else if (tbzzData && tbzzData.length > 0) {
              this.yearCodeArray = tbzzData.map((item) => {
                if (item.yearCode && item.yearCode.length === 4) {
                  return item.yearCode + "00";
                }
                return item.yearCode;
              });
            } else if (ljzzData && ljzzData.length > 0) {
              this.yearCodeArray = ljzzData.map((item) => {
                if (item.yearCode && item.yearCode.length === 4) {
                  return item.yearCode + "00";
                }
                return item.yearCode;
              });
            }

            let dyzUnit = "",
              ljzUnit = "",
              tbzzUnit = "",
              ljzzUnit = "";

            this.yearCodeArray.forEach((yearCode) => {
              let dyzItem = dyzData.find((item) => item.yearCode === yearCode);
              if (dyzItem && !dyzUnit) {
                dyzUnit = dyzItem.unit;
              }

              let ljzItem = ljzData.find((item) => item.yearCode === yearCode);
              if (ljzItem && !ljzUnit) {
                ljzUnit = ljzItem.unit;
              }

              let tbzzItem = tbzzData.find(
                (item) => item.yearCode === yearCode
              );
              if (tbzzItem && !tbzzUnit) {
                tbzzUnit = tbzzItem.unit;
              }

              let ljzzItem = ljzzData.find(
                (item) => item.yearCode === yearCode
              );
              if (ljzzItem && !ljzzUnit) {
                ljzzUnit = ljzzItem.unit;
              }

              let year = yearCode.substring(0, 4);
              let month = yearCode.substring(4);
              let dateStr = year + "年";
              if (month && month !== "00") {
                dateStr += month + "月";
              }

              this.dateCategoryData.push(dateStr);

              let obj = new Object();
              obj["date"] = dateStr;
              obj["dyzStrdata"] = dyzItem ? dyzItem.strdata : "-";
              obj["ljzStrdata"] = ljzItem ? ljzItem.strdata : "-";
              obj["tbzzStrdata"] = tbzzItem ? tbzzItem.strdata : "-";
              obj["ljzzStrdata"] = ljzzItem ? ljzzItem.strdata : "-";

              this.tableData.push(obj);
            });

            this.dyzUnit = dyzUnit;
            this.ljzUnit = ljzUnit;
            this.tbzzUnit = tbzzUnit;
            this.ljzzUnit = ljzzUnit;
          }

          this.dateCategoryData.reverse();
          this.yearCodeArray.reverse();
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    dateFormat (cellValue, format) {
      if (!cellValue) return "";
      return moment(cellValue).format(format);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/search.scss";
@import "@/assets/css/statist.scss";

::v-deep .el-tree {
  padding-left: 25px;

  .el-tree-node__content {
    padding-left: 0px !important;
    white-space: normal;
    height: auto;
    padding: 5px 0;

    > label.el-checkbox.is-disabled {
      display: none;
    }
  }

  .el-tree-node {
    position: relative;
    // padding-left: 16px;

    .el-tree-node__children {
      padding-left: 16px;

      .el-tree-node__content {
        padding-left: 0px !important;
        white-space: normal;
        height: auto;
        padding: 5px 0;
      }
    }

    &:last-child:before {
      height: 38px;
    }
    &:before {
      border-left: none;
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
    &:after {
      border-top: none;
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
  }
}

::v-deep .search-filter {
  .el-range-separator {
    line-height: 38px;
    padding: 0 10px;
  }
}
</style>